// src/components/Layout/MobileNav.js
import React, { useContext } from 'react';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { BottomNavigation, BottomNavigationAction, Paper, useTheme } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import StarIcon from '@mui/icons-material/Star';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';

export default function MobileNav() {
  const { authData, setAuthData } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  // Get current active route
  const getCurrentValue = () => {
    const path = location.pathname;
    if (path.includes('/creators')) return 0;
    if (path.includes('/leaderboard')) return 1;
    if (path.includes('/reviews')) return 2;
    if (path.includes('/dashboard')) return 3;
    return -1;
  };

  const logout = () => {
    setAuthData(null);
    navigate('/login');
  };

  return (
    <Paper 
      elevation={8} 
      data-tutorial-id="bottom-nav"
      sx={{ 
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1300,
        borderRadius: '16px 16px 0 0',
        overflow: 'hidden'
      }}
    >
      <BottomNavigation
        showLabels
        value={getCurrentValue()}
        sx={{
          height: 64,
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            padding: '6px 0',
            color: theme.palette.text.secondary,
            '&.Mui-selected': {
              color: theme.palette.primary.main,
            },
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.7rem',
            fontWeight: 500,
            '&.Mui-selected': {
              fontSize: '0.75rem',
              fontWeight: 600,
            },
          },
        }}
      >
        <BottomNavigationAction
          label="Creators"
          icon={<PeopleIcon />}
          component={RouterLink}
          to="/creators"
          data-tutorial-id="creators-nav-item"
          sx={{
            transition: 'transform 0.2s',
            '&:active': {
              transform: 'scale(0.95)',
            },
          }}
        />
        <BottomNavigationAction
          label="Leaderboard"
          icon={<EmojiEventsIcon />}
          component={RouterLink}
          to="/leaderboard"
          data-tutorial-id="leaderboard-nav-item"
          sx={{
            transition: 'transform 0.2s',
            '&:active': {
              transform: 'scale(0.95)',
            },
          }}
        />
        <BottomNavigationAction
          label="Reviews"
          icon={<StarIcon />}
          component={RouterLink}
          to="/reviews"
          data-tutorial-id="reviews-nav-item"
          sx={{
            transition: 'transform 0.2s',
            '&:active': {
              transform: 'scale(0.95)',
            },
          }}
        />
        <BottomNavigationAction
          label="Profile"
          icon={<AccountCircleIcon />}
          component={RouterLink}
          to="/dashboard"
          data-tutorial-id="profile-nav-item"
          sx={{
            transition: 'transform 0.2s',
            '&:active': {
              transform: 'scale(0.95)',
            },
          }}
        />
        <BottomNavigationAction
          label="Logout"
          icon={<LogoutIcon />}
          onClick={logout}
          sx={{
            transition: 'transform 0.2s',
            '&:active': {
              transform: 'scale(0.95)',
            },
          }}
        />
      </BottomNavigation>
    </Paper>
  );
}
